import React from 'react';
import { Typography, Button, IconButton, Tooltip } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutlineSharp';
import { makeStyles } from '@material-ui/core/styles';

import { helpUrl } from '../utils/linksLib';

const useStyles = makeStyles((theme) => ({
  helpButton: {
    fontSize: '0.8em',
    height: '50px',
    outline: 'none !important',
  },
  helpButtonIconOnly: {
    fontSize: '0.8em',
    width: '50px',
    height: '50px',
    outline: 'none !important',
    opacity: 0.5,
  },
  helpIcon: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    opacity: 0.5,
  },
  helpText: {
    color: '#aaa',
    fontSize: '1.3em',
    letterSpacing: '-0.03em',
    marginRight: theme.spacing(0.5),
  },
}));

export default function HelpButton(props) {
  const { iconOnly } = props;
  const classes = useStyles();

  async function onClick() {
    window.open(helpUrl, '_blank');
  }

  return (<>
    {iconOnly && (
      <IconButton
        className={classes.helpButtonIconOnly}
        onClick={onClick}
      >
      <Tooltip title='Help'>
        <HelpOutlineIcon fontSize='large' color='secondary' />
      </Tooltip>
      </IconButton>
    )}
    {!iconOnly && (
      <Button
        className={classes.helpButton}
        onClick={onClick}
      >
        <HelpOutlineIcon className={classes.helpIcon} color='secondary' />
        <Typography variant='h3' className={classes.helpText}>
          Help
        </Typography>
      </Button>
    )}
  </>);
}
